var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;


//////////////////
// WEBPACK FOOTER
// ./~/_can-use-dom@0.1.0@can-use-dom/index.js
// module id = 1594
// module chunks = 1